import axios, { AxiosInstance, AxiosResponse } from "axios"
import { LoginResponse } from "../../@types/DRO/LoginResponse"
import { FormSubmissionData } from "../../@types/DTO/FormSubmissionData"
import {
    EmployeeList,
    FormDataResponse,
    FormDataResponseCount,
    FormSubmissionResponse,
} from "../../@types/DRO/FormSubmissionResponse"
import { MediaUploadFileIdResponse } from "../../@types/DRO/MediaFileUploadResponse"
import { DataFromMobileOtpResponse } from "../../@types/DRO/MobileOtpResponse"

export class FormDatasSubmission {
    public static api = new FormDatasSubmission()
    private instance: AxiosInstance

    constructor() {
        this.instance = axios.create({
            baseURL: "https://stag-micro.bcykal.com/mobycy/kyc",
            headers: {
                "Content-Type": "application/json",
            },
        })
    }

    getToken() {
        return localStorage.getItem("token")
    }
    async insertVisitorInfo(
        visitorData: FormSubmissionData
    ): Promise<FormSubmissionResponse> {
        try {
            const token = this.getToken()
            const response: AxiosResponse<FormSubmissionResponse> =
                await this.instance.post(
                    `/api/insert/visitor/info`,
                    visitorData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                )
            return response.data
        } catch (error) {
            throw new Error("Failed to insert visitor info")
        }
    }
    async updateVisitorInfo(
        id: string,
        status: string,
        visitorData: FormSubmissionData
    ): Promise<FormSubmissionResponse> {
        try {
            const token = this.getToken()
            const response: AxiosResponse<FormSubmissionResponse> =
                await this.instance.put(
                    `/api/update/visitor/status`,
                    visitorData,
                    {
                        params: {
                            id,
                            status,
                        },
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                )
            return response.data
        } catch (error) {
            throw new Error("Failed to update visitor info")
        }
    }
    async getVisitorStats(): Promise<FormDataResponseCount> {
        try {
            const token = this.getToken()
            const response: AxiosResponse<FormDataResponseCount> =
                await this.instance.get(`/api/visitors/stats`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })

            return response.data
        } catch (error) {
            throw new Error("Failed to fetch visitor stats")
        }
    }
    async getVisitorsData(
        status: string,
        startDate: Date | null | string,
        endDate: Date | null | string
    ): Promise<FormDataResponse> {
        try {
            const token = this.getToken()
            const response: AxiosResponse<FormDataResponse> =
                await this.instance.get(`/api/visitors/history/data`, {
                    params: {
                        status,
                        startDate,
                        endDate,
                    },

                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
            return response.data
        } catch (error) {
            throw new Error("Failed to fetch data")
        }
    }

    mediaUploadFileId(
        file: File
    ): Promise<AxiosResponse<MediaUploadFileIdResponse>> {
        const formData = new FormData()
        formData.append("file", file)

        return this.instance.post<MediaUploadFileIdResponse>(
            "https://preprod.bcykal.com/mobycy/api/media/file/upload",
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${this.getToken()}`,
                },
            }
        )
    }

    async downLoadFile(fileId: number): Promise<Blob> {
        try {
            const response = await axios.get(
                `https://preprod.bcykal.com/mobycy/api/media/file/${fileId}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${this.getToken()}`,
                    },
                    responseType: "blob",
                }
            )
            return response.data
        } catch (error) {
            console.error("Error fetching file URL:", error)
            throw new Error("Failed to download file")
        }
    }

    async fetchDataFromMobileOtp(
        phoneNumber: string
    ): Promise<DataFromMobileOtpResponse> {
        const response: AxiosResponse<DataFromMobileOtpResponse> =
            await this.instance.get("/api/get/visitor/data", {
                params: {
                    phoneNumber,
                },

                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
            })

        return response.data
    }

    async getEmployeeList(
        page: string,
        pageSize: string,
        search:string
    ): Promise<EmployeeList> {
        try {
            const token = this.getToken()
            const response: AxiosResponse<EmployeeList> =
                await this.instance.get(`/api/get/employee`, {
                    params: {
                       page,
                       pageSize,
                       search
                    },

                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
            return response.data
        } catch (error) {
            throw new Error("Failed to fetch data")
        }
    }

}
